import { ref } from 'vue';

import { administrationApiSdk } from '../sdk/administrationClient.js';

import { defineCollectionStore } from './collectionStore.js';

/**
 * Companies — the legal entities everything else in Administration names.
 *
 * The one addition is what names the Company on screen. A caller shows it before
 * retiring one: a Company that is still somebody's payer cannot be retired, and
 * finding that out before the refusal rather than after it is the whole point of
 * the route.
 */
export const useCompaniesStore = defineCollectionStore({
    id: 'administration-companies',
    client: administrationApiSdk.companies,
    extend({ client, attempt }) {
        const referencing = ref([]);

        async function loadReferencing(id) {
            const attempted = await attempt(function () {
                return client.referencing(id);
            });
            if (attempted.ok === false) {
                return false;
            }
            referencing.value = attempted.value.referencing;
            return true;
        }

        return { referencing, loadReferencing };
    }
});

export default useCompaniesStore;
